export const PDF_CONVERT_SUPPORTED_EXTENSIONS = [
    'doc',
    'docm',
    'docx',
    'dot',
    'dotm',
    'dotx',
    'htm',
    'html',
    'odp',
    'odt',
    'pdf',
    'pot',
    'pps',
    'ppt',
    'pptm',
    'pptx',
    'rtf',
    'txt',
    'wpd',
];
export const canBeConvertedToPdf = (extension) => {
    return PDF_CONVERT_SUPPORTED_EXTENSIONS.includes(extension);
};
/**
 * Composes an attachment's display name by prepending its stored number, separated by a single
 * space. Any extra punctuation lives in the number format token itself (e.g. "Exhibit {n}:").
 * Used in flat-string contexts (document exports, viewer titles, accessibility labels); UI lists
 * should generally render the number and name as separate elements instead.
 * @param attachmentNumber - The stored attachment number (e.g. "Exhibit A"), or null/undefined when unnumbered
 * @param attachmentName - The attachment's name
 * @returns The display name: `{number} {name}`, or just the name when there is no number
 */
export const formatAttachmentDisplayName = (attachmentNumber, attachmentName) => (attachmentNumber ? `${attachmentNumber} ${attachmentName}` : attachmentName);
